// Okładki z zewnętrznego CDN (0,6–1 MB każda) podmieniamy na lokalne, zoptymalizowane pliki
// /img/covers/<id>.jpg (20–170 KB). Działa niezależnie od tego, co jest w bazie produkcyjnej.
const LOCAL_IDS = new Set([
  "cien-nad-wisla", "ostatni-list-z-lizbony", "sprawa-numer-siedem", "cicha-woda", "kroniki-rozbitego-nieba",
  "magia-mglistych-wysp", "kod-przyszlosci", "startup-od-zera", "negocjuj-jak-pro", "inwestycje-dla-kazdego",
  "sila-malych-krokow", "spokoj-w-glowie", "mindfulness-dla-zabieganych", "domowe-finanse-bez-tajemnic",
  "kuchnia-roslinna-na-co-dzien", "detektyw-z-krakowa", "digilingua-hiszpanski", "digilingua-angielski",
  "digilingua-niemiecki", "digilingua-francuski", "digilingua-chinski", "digimind-pamiec", "digitutor-ai",
]);

// Najnowsze okładki DigiKids (z maskotkami Libi i Digi) są w plikach .jpeg
const LOCAL_JPEG = new Set(["digikids-czytanie", "digikids-matematyka"]);

export function coverSrc(item) {
  const url = item?.cover_image;
  if (!url) return url;
  if (!item.id || !/^https?:\/\//.test(url)) return url;
  if (LOCAL_JPEG.has(item.id)) return `/img/covers/${item.id}.jpeg`;
  if (LOCAL_IDS.has(item.id)) return `/img/covers/${item.id}.jpg`;
  return url;
}
